import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config";
import ChatTranscriptsWindow from "./ChatTranscriptsWindow";
import { CircularProgress, Box } from "@mui/material";

function ChatTranscriptsCalling() {
  const { customer_id } = useParams();
  const [chatData, setChatData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch chat transcript from backend
  useEffect(() => {
    fetchChatTranscript();
  }, [customer_id]);

  const fetchChatTranscript = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${config.API_BASE_URL_V1}/admin/chat-transcripts/transcript/${customer_id}`
      );

      console.log("Chat transcript response:", response.data);

      if (response.data.success && response.data.data) {
        setChatData(response.data.data);
      } else {
        setError(response.data.message || "Failed to fetch chat transcript");
      }
    } catch (err) {
      console.error("Error fetching chat transcript:", err);
      setError(`Error loading chat transcript: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2} color="error.main">
        {error}
      </Box>
    );
  }

  return <ChatTranscriptsWindow chatData={chatData} />;
}

export default ChatTranscriptsCalling;
